import { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { queryKeys } from "@src/config/queryKeys";
import { getReanalyzeSingleTestUrl } from "@src/config/baseUrls";

const useReanalyzeSingleTest = () => {
  const axios = useAxios();

  return useMutation<
    AxiosResponse,
    AxiosError,
    { studyId: string; testId: number }
  >(queryKeys.REANALYZE_Test, (values) =>
    axios.put(getReanalyzeSingleTestUrl(values.studyId, values.testId)),
  );
};

export default useReanalyzeSingleTest;
